import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=230e51dd&scoped=true&lang=html&"
import script from "./invite.vue?vue&type=script&lang=ts&"
export * from "./invite.vue?vue&type=script&lang=ts&"
import style0 from "./invite.vue?vue&type=style&index=0&id=230e51dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e51dd",
  null
  
)

export default component.exports